import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import ShopifyStockTable from './components/ShopifyStockTable';

const ShopifyStock = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Fulfilment / Shopify / Stock</h5>
      </Col>
    </Row>
    <Row>
      <ShopifyStockTable />
    </Row>
  </Container>
);

export default ShopifyStock;
